import React from 'react';
import documentIcon from '../../assets/images/icons/document.svg';
import videoIcon from '../../assets/images/icons/video.svg';
import linkIcon from '../../assets/images/icons/link.svg';
import Styles from './Link.module.scss';

const Link = (props) => {
  const { article, fittingRecLink } = props;
  const iconMap = {
    document: documentIcon,
    video: videoIcon,
    link: linkIcon,
  };

  const renderIcon = (type) => {
    return iconMap[type] ?? '';
  };

  return (
    <div className={Styles.link}>
      <a href={article.link} target='__blank'>
        <div className={`${Styles.linkDisplay} ${fittingRecLink ? Styles.fittingRecLink : Styles.authorLink}`}>
          <img className={Styles.linkIcon} src={renderIcon(article.type)} alt='type' />
          <span>{article.title}</span>
        </div>
      </a>
    </div>
  );
};

export default Link;
